<div
  class="bigBannerHomepage"
  [class.bigBannerHomepage--toolbar-active]="heroToolbarActive"
>
  <!-- Carousel hero custom: una sola immagine al 100% (evita layout affiancato di p-galleria) -->
  <div class="hero-carousel">
    <img
      *ngIf="images.length && images[heroActiveSlide]"
      [src]="images[heroActiveSlide].itemImageSrc"
      class="gallery-image"
      alt=""
    />
    <ul *ngIf="images.length > 1" class="hero-carousel__dots" aria-label="Hero slides">
      <li *ngFor="let _img of images; let i = index">
        <button
          type="button"
          class="hero-carousel__dot"
          [class.hero-carousel__dot--active]="i === heroActiveSlide"
          (click)="goToHeroSlide(i)"
          [attr.aria-label]="'Slide ' + (i + 1)"
          [attr.aria-current]="i === heroActiveSlide ? 'true' : null"
        ></button>
      </li>
    </ul>
  </div>
  <div class="hero-overlay" aria-hidden="true"></div>
  <div class="wrap-slider">
    <div class="container-slider">
      <h1 class="hero-title">
        <span class="hero-title__line">{{ 'HOMEPAGE.HERO_TITLE_LINE1' | translate }}</span>
        <span class="hero-title__line">{{ 'HOMEPAGE.HERO_TITLE_LINE2' | translate }}</span>
      </h1>
      <p class="hero-subtitle">
        {{ 'HOMEPAGE.HERO_SUBTITLE' | translate: {count: experiencesStats.experiencesNum} }}
      </p>

      <div class="hero-toolbar-outer">
      <div
        class="searchbarHomepage"
        (focusin)="heroToolbarActive = true"
        (focusout)="onHeroSearchbarFocusOut()"
      >
        <!-- Località -->
        <div class="searchbarHomepage__segment searchbarHomepage__segment--location">
          <i class="pi pi-search searchbarHomepage__icon" aria-hidden="true"></i>
          <input
            class="searchbarHomepage__input searchbarHomepage__input--text"
            type="text"
            [(ngModel)]="searchText"
            (focus)="locationPanel.show($event)"
            (input)="locationPanel.show($event)"
            [placeholder]="'HOMEPAGE.SEARCH_PLACEHOLDER' | translate"
            autocomplete="off"
          />
          <button
            *ngIf="searchText?.length"
            type="button"
            class="searchbarHomepage__clear"
            (click)="clearLocationSearch(); $event.stopPropagation()"
            [attr.aria-label]="'HOMEPAGE.CLEAR_SEARCH' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          <p-overlayPanel
            #locationPanel
            [dismissable]="true"
            [showCloseIcon]="false"
            styleClass="hero-location-panel"
            [attr.data-hero-search-overlay]="true"
          >
            <ul class="hero-location-suggestions" *ngIf="getHeroLocationSuggestions().length; else noLocSuggestions">
              <li
                *ngFor="let s of getHeroLocationSuggestions()"
                class="hero-location-suggestions__item"
                (click)="selectHeroLocation(s); locationPanel.hide()"
              >
                <span class="hero-location-suggestions__dot"></span>
                <span class="hero-location-suggestions__text">
                  <span class="hero-location-suggestions__label">{{ s.label }}</span>
                  <span class="hero-location-suggestions__sub" *ngIf="s.sub">{{ s.sub }}</span>
                </span>
              </li>
            </ul>
            <ng-template #noLocSuggestions>
              <p class="hero-location-suggestions__empty m-0 text-sm text-color-secondary px-3 py-2">
                {{ 'HOMEPAGE.LOCATION_TYPE_HINT' | translate }}
              </p>
            </ng-template>
          </p-overlayPanel>
        </div>

        <span class="searchbarHomepage__divider" role="presentation"></span>

        <!-- Data / periodo -->
        <div class="searchbarHomepage__segment searchbarHomepage__segment--trigger">
          <i class="pi pi-map-marker searchbarHomepage__icon" aria-hidden="true"></i>
          <button type="button" class="searchbarHomepage__input searchbarHomepage__btn" (click)="calendarPopUp.toggle($event)">
            {{ datesText }}
          </button>
          <i class="pi pi-angle-down searchbarHomepage__chevron" aria-hidden="true"></i>
          <p-overlayPanel
            #calendarPopUp
            styleClass="hero-calendar-panel"
            [attr.data-hero-search-overlay]="true"
          >
            <div class="hero-calendar-panel__inner">
              <div class="hero-calendar-panel__summary" *ngIf="heroCalendarRangeSummary as sum">
                {{ sum }}
              </div>
              <p-calendar
                [(ngModel)]="rangeDates"
                selectionMode="range"
                inputId="icondisplay"
                styleClass="hero-datepicker-calendar"
                [locale]="heroCalendarLocale"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="'2018:2040'"
                dateFormat="dd/mm/yy"
                [showTime]="false"
                [readonlyInput]="true"
                [placeholder]="'HOMEPAGE.DATE_PLACEHOLDER' | translate"
                [inline]="true"
                [minDate]="minDate"
                [showButtonBar]="false"
              ></p-calendar>
              <div class="hero-calendar-panel__footer">
                <button
                  type="button"
                  class="hero-calendar-panel__clear-link"
                  (click)="clearHeroDateRange(); calendarPopUp.hide()"
                >
                  {{ 'HOMEPAGE.CLEAR_DATES_FOOTER' | translate }}
                </button>
              </div>
            </div>
          </p-overlayPanel>
          <button
            type="button"
            class="searchbarHomepage__segment-action"
            (click)="fieldReset(1); calendarPopUp.hide()"
            *ngIf="iconCalendar === closeIcon"
            [attr.aria-label]="'HOMEPAGE.CLEAR_DATES' | translate"
          >
            <i [class]="iconCalendar"></i>
          </button>
        </div>

        <span class="searchbarHomepage__divider" role="presentation"></span>

        <!-- Persone -->
        <div class="searchbarHomepage__segment searchbarHomepage__segment--trigger">
          <i class="pi pi-user-plus searchbarHomepage__icon" aria-hidden="true"></i>
          <button type="button" class="searchbarHomepage__input searchbarHomepage__btn" (click)="personPopUp.toggle($event)">
            {{ numPersone }}
          </button>
          <i class="pi pi-angle-down searchbarHomepage__chevron" aria-hidden="true"></i>
          <p-overlayPanel #personPopUp styleClass="hero-person-panel" [attr.data-hero-search-overlay]="true">
            <div class="flex flex-row align-items-start gap-4">
              <div class="pr-3">
                <p class="m-0 font-semibold">{{ 'HOMEPAGE.PEOPLE' | translate }}</p>
                <p class="m-0 mt-1 text-sm text-color-secondary">{{ 'HOMEPAGE.SELECT_NUMBER' | translate }}</p>
              </div>
              <div class="flex align-items-center justify-content-center">
                <p-inputNumber
                  [(ngModel)]="numPax"
                  [showButtons]="true"
                  buttonLayout="horizontal"
                  placeholder="0"
                  inputId="horizontal"
                  inputStyleClass="miroInput"
                  spinnerMode="horizontal"
                  [step]="1"
                  decrementButtonClass="miroButtons"
                  incrementButtonClass="miroButtons"
                  incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus"
                  min="1"
                  [max]="numberOfExperiences"
                />
              </div>
            </div>
          </p-overlayPanel>
          <button
            type="button"
            class="searchbarHomepage__segment-action"
            (click)="fieldReset(2); personPopUp.hide()"
            *ngIf="iconPerson === closeIcon"
            [attr.aria-label]="'HOMEPAGE.CLEAR_PEOPLE' | translate"
          >
            <i [class]="iconPerson"></i>
          </button>
        </div>

        <span class="searchbarHomepage__divider searchbarHomepage__divider--before-cta" role="presentation"></span>

        <div class="searchbarHomepage__cta">
          <button type="button" class="searchbarHomepage__search-btn" (click)="linkToExperiences()">
            {{ 'HOMEPAGE.SEARCH' | translate }}
          </button>
        </div>
      </div>

      <div class="hero-nearme-row">
        <a href="#" class="hero-nearme-link" (click)="$event.preventDefault(); linkToExperiences()">
          {{ 'HOMEPAGE.EXPERIENCES_AROUND' | translate }}
        </a>
      </div>
      </div>
    </div>
  </div>
</div>
<main class="site-content">
  <div class="unselectable container">
    <div class="introTextHomepage my-8">
      <div class="text-center">
        <h2 class="m-0">
          {{ 'HOMEPAGE.MORE_THAN_PROPOSALS' | translate: {count: experiencesStats.experiencesNum} }}
        </h2>
        <p>
          {{ 'HOMEPAGE.CHOOSE_DESCRIPTION' | translate }}
        </p>
      </div>
      <div class="counterHomepage flex align-items-center justify-content-evenly mt-6 mx-0 md:mx-6">
        <div class="flex-1 md:flex-none m-2 pl-4">
          <span class="font-bolder block text-4xl mb-1">{{ experiencesStats.experiencesNumReal }}+</span>
          <small>{{ 'HOMEPAGE.EXPERIENCES_COUNT' | translate }}</small>
        </div>
        <div class="flex-1 md:flex-none m-2 pl-4">
          <span class="font-bolder block text-4xl mb-1 mb-1">{{ experiencesStats.regions }}+</span>
          <small>{{ 'HOMEPAGE.REGIONS_TERRITORIES' | translate }}</small>
        </div>
        <div class="flex-1 md:flex-none m-2 pl-4">
          <span class="font-bolder block text-4xl mb-1">{{ experiencesStats.wineries }}+</span>
          <small>{{ 'HOMEPAGE.PARTNER_WINERIES' | translate }}</small>
        </div>
        <div class="flex-1 md:flex-none m-2 pl-4">
          <span class="font-bolder block text-4xl mb-1">{{ experiencesStats.users }}+</span>
          <small>{{ 'HOMEPAGE.DIVINEA_USERS' | translate }}</small>
        </div>
      </div>
    </div>

    <div class="carouselExperiencesHomepage my-8 pt-5">
      <div class="text-center">
        <h2 class="m-0">{{ 'HOMEPAGE.SELECTED_FOR_YOU' | translate }}</h2>
        <p class="mb-6">
          {{ 'HOMEPAGE.CHOOSE_EXPERIENCE' | translate: {count: experiencesStats.experiencesNum} }}
        </p>
      </div>
      <div class="carouselExperiencesSelected">
        <p-carousel
          [value]="experienceHomepagePages"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="false"
          [showNavigators]="experienceHomepagePages.length > 1"
          [showIndicators]="experienceHomepagePages.length > 1"
        >
          <ng-template let-page pTemplate="item">
            <div class="experiences-carousel-page">
              <app-experience-card
                class="experiences-carousel-page__cell"
                *ngFor="let exp of page; trackBy: trackByExperienceId"
                [experience]="exp"
                (click)="linkToExperience(exp.id, exp.details?.title || exp.title || '')"
              ></app-experience-card>
            </div>
          </ng-template>
        </p-carousel>
      </div>
      <div class="flex justify-content-center mt-5">
        <a
          class="link-scopri link-scopri--wide no-underline inline-block mt-2 pl-6 pr-6 font-bold"
          [routerLink]="experiencesListUrl"
        >
          {{ 'HOMEPAGE.DISCOVER_ALL' | translate }}
        </a>
      </div>
    </div>

    <section class="corporationSectionHomepage">

        <div class="corporationInner flex flex-row justify-content-around gap-6 align-items-center">
        <div class="corporationImage">
          <img src="../../../assets/images/scopri-proposte-per-cantina.png" />
        </div>
        <div class="corporationContent">
          <h2>
            {{ 'HOMEPAGE.COMPANY_TITLE' | translate }}
          </h2>
          <div>
            <p>{{ 'HOMEPAGE.COMPANY_DESCRIPTION' | translate }}</p>
            <ul>
              <li>{{ 'HOMEPAGE.CORPORATE_EVENTS' | translate }}</li>
              <li>{{ 'HOMEPAGE.ONLINE_TASTINGS' | translate }}</li>
              <li>{{ 'HOMEPAGE.TEAM_BUILDING' | translate }}</li>
            </ul>
            <p>{{ 'HOMEPAGE.MORE_INFO_COMPANIES' | translate }}</p>
          </div>
          <div>
            <a class="link-scopri no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="#">{{ 'HOMEPAGE.DISCOVER_MORE' | translate }}</a>
          </div>
        </div>
      </div>
    </section>

    <section class="carouselWineRegionHomepage my-8 pt-5">
      <div class="text-center">
        <h2 class="m-0">{{ 'HOMEPAGE.EXPLORE_TERRITORIES' | translate }}</h2>
        <p class="mb-6">
          {{ 'HOMEPAGE.TERRITORIES_DESCRIPTION' | translate }}
        </p>
      </div>
      <div class="carouselTerritoryRow">
        <p-carousel
          [value]="wineRegionsHomepagePages"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="false"
          [showNavigators]="wineRegionsHomepagePages.length > 1"
          [showIndicators]="wineRegionsHomepagePages.length > 1"
        >
          <ng-template let-page pTemplate="item">
            <div class="territory-carousel-row">
              <app-wine-region-card
                *ngFor="let region of page; trackBy: trackByWineRegionId"
                [wineRegion]="region"
                (click)="linkToRegion(region)"
              ></app-wine-region-card>
            </div>
          </ng-template>
        </p-carousel>
      </div>
      <div class="flex justify-content-center mt-5">
        <a class="link-scopri no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="#">{{ 'HOMEPAGE.LOAD_MORE' | translate }}
        </a>
      </div>
    </section>

    <section class="carouselRegionsHomepage my-8 pt-5">
      <div>
        <div class="text-center">
          <h2 class="m-0">{{ 'HOMEPAGE.EXPLORE_REGIONS' | translate }}</h2>
          <p class="mb-6">
            {{ 'HOMEPAGE.REGIONS_DESCRIPTION' | translate }}
          </p>
        </div>
        <div class="carouselTerritoryRow">
          <p-carousel
            [value]="geographicRegionsHomepagePages"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="false"
            [showNavigators]="geographicRegionsHomepagePages.length > 1"
            [showIndicators]="geographicRegionsHomepagePages.length > 1"
          >
            <ng-template let-page pTemplate="item">
              <div class="territory-carousel-row">
                <app-region-card
                  *ngFor="let region of page; trackBy: trackByGeographicRegionId"
                  [region]="region"
                  (click)="linkToRegion(region)"
                ></app-region-card>
              </div>
            </ng-template>
          </p-carousel>
        </div>

        <div class="flex justify-content-center mt-5">
          <a class="link-scopri no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="#">{{ 'HOMEPAGE.LOAD_MORE' | translate }}
          </a>
        </div>
      </div>
    </section>

    <section class="wineSuiteHomepage my-8 pt-5">
      <div class="wine-suite-card p-6"
        style="display: flex; flex-direction: row; justify-content: center;align-items: center; gap: 2rem;">
        <div style="flex:1;">
          <h2 class="text-white text-5xl mb-6 mt-0 line-height-2">{{ 'HOMEPAGE.WINERY_TITLE' | translate }}<br>Scopri <img
              src="https://wine-suite.com/wp-content/uploads/2022/07/wine-suite-white.svg" /></h2>



          <p class="text-white text-lg mb-6">
            {{ 'HOMEPAGE.WINE_SUITE_DESCRIPTION' | translate }}
          </p>
          <a class="link-scopri-winesuite no-underline inline-block mt-3 pl-6 pr-6 font-bold"
            href="https://wine-suite.com/" target="_blank" style="color: #173D4F">{{ 'HOMEPAGE.DISCOVER_MORE' | translate }}
          </a>


        </div>
        <div style="display: flex; justify-content: center; align-items: center;flex:1;">
          <img
            alt="Wine Suite"
            src="https://wine-suite.com/wp-content/uploads/2022/12/Wine-Suite-Piattaforma-CRM-450x450.png"
          />
        </div>
      </div>
    </section>

    <section class="blogPostsHomepage my-8 pt-5">
      <header class="text-center">
        <h2 class="m-0">{{ 'HOMEPAGE.FEATURED' | translate }}</h2>
        <p class="mb-6">
          {{ 'HOMEPAGE.BLOG_DESCRIPTION' | translate }}
        </p>
      </header>
      <div *ngIf="error" class="blog-error">
        <p>{{error}}</p>
      </div>

      <div class="posts-grid posts-skeleton" *ngIf="loadingPosts">
        <div class="post-card skeleton-card" *ngFor="let i of [1,2,3]">
          <div class="skeleton-image"></div>
          <div class="skeleton-line w-full"></div>
          <div class="skeleton-line w-3/4"></div>
          <div class="skeleton-line w-1/2"></div>
        </div>
      </div>

      <div class="posts-grid" *ngIf="!loadingPosts && posts && posts.length > 0">
        <article *ngFor="let post of posts; let i = index" class="post-card" [class.featured]="i === 0">
          <a [href]="post.link" target="_blank" class="no-underline" rel="noopener noreferrer">
            <img [src]="getFeaturedImage(post)" [alt]="post.title" class="post-image">
            <div class="post-content">
              <h3 class="post-title">{{ post.title }}</h3>
              <p class="post-excerpt">{{ getExcerpt(post) }}</p>
              <div class="flex align-items-center justify-content-between">
                <div class="tags-container">
                  <a *ngFor="let tag of getTags(post)" href="#" class="tag" (click)="$event.preventDefault()">#{{ tag }}</a>
                </div>
                <span class="read-more pi pi-arrow-right"></span>
              </div>
            </div>
          </a>
        </article>
      </div>

      <div class="text-center mt-4" *ngIf="!loadingPosts && posts.length === 0 && !error">
        <p class="text-500">{{ 'HOMEPAGE.BLOG_NO_POSTS' | translate }}</p>
      </div>
      <footer class="text-center mt-6">
        <p-button class="divineaBodyButton no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="https://divinea.com/blog/">
          {{ 'HOMEPAGE.GO_TO_BLOG' | translate }}
        </p-button>
      </footer>
    </section>
  </div>
</main>